import React, { useState } from 'react';
import { Pressable, HStack, Stack, Box } from 'native-base';
import { Iconography, Typography } from 'fmc-digital-common';
const FilterDropDown = ({
  options,
  onSelect,
  initialFilter
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialFilter);
  const handleToggleOptions = () => {
    setShowOptions(!showOptions);
  };
  const handleSelectOption = option => {
    setSelectedOption(option.label);
    onSelect(option.value);
    setShowOptions(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pressable, {
    onPress: handleToggleOptions
  }, /*#__PURE__*/React.createElement(HStack, {
    height: 12,
    bg: 'white.500',
    borderColor: "lightGray.250",
    width: {
      base: 190,
      sm: 190,
      md: 200,
      lg: 200
    },
    borderWidth: 1,
    borderRadius: 2,
    justifyContent: {
      base: 'flex-start',
      lg: 'flex-start'
    },
    alignItems: 'center',
    color: "text.running"
  }, /*#__PURE__*/React.createElement(Typography, {
    padding: 4,
    variant: 'regular',
    color: 'grey.900',
    testID: `selected-${selectedOption}`,
    accessibilityLabel: `${selectedOption}`,
    accessibilityRole: "text"
  }, selectedOption), /*#__PURE__*/React.createElement(HStack, {
    alignSelf: 'center',
    justifyContent: {
      base: 'center',
      lg: 'center'
    },
    width: 12,
    backgroundColor: 'lightBlue.400',
    height: '100%',
    marginLeft: 'auto'
  }, /*#__PURE__*/React.createElement(Stack, {
    alignSelf: 'center'
  }, showOptions ? /*#__PURE__*/React.createElement(Iconography, {
    name: 'keyboard-arrow-down-icon',
    color: "primary.800",
    size: 30
  }) : /*#__PURE__*/React.createElement(Iconography, {
    name: 'keyboard-arrow-up-icon',
    color: "primary.800",
    size: 30
  }))))), showOptions && /*#__PURE__*/React.createElement(Box, {
    zIndex: 2000,
    position: 'absolute',
    backgroundColor: 'white.500',
    marginTop: 12,
    opacity: 1,
    width: '100%',
    shadow: 9,
    borderRadius: 4
  }, options.map((option, index) => /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => handleSelectOption(option),
    key: index,
    _hover: {
      backgroundColor: 'lightBlue.400'
    },
    _pressed: {
      backgroundColor: 'lightBlue.400'
    }
  }, ({
    isHovered,
    isPressed,
    isFocused
  }) => {
    return /*#__PURE__*/React.createElement(Typography, {
      paddingY: 2,
      paddingLeft: 4,
      variant: 'regular',
      color: 'darkGray.900',
      testID: `option-${option.label}`,
      accessibilityLabel: `${option.label}`,
      backgroundColor: isHovered || isFocused || isPressed ? 'lightBlue.400' : 'white.500',
      accessibilityRole: "text"
    }, option.label);
  }))));
};
export default FilterDropDown;
//# sourceMappingURL=index.js.map